import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MfaRequiredGuard  {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (!environment.mfaRequired) return true;
    const user = this.auth.getCurrentUser();
    if (user && !user.mfaEnabled) {
      return this.router.createUrlTree(['/mfa-required']);
    }
    return true;
  }
}
